import React from 'react';
import highFees from '../images/highFees.jpeg';

function HighSchoolFees() {
  const bannerStyle = {
    width: '100%',
    height: '450px',
    backgroundImage: `url(${highFees})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center 75%',
    backgroundRepeat: 'no-repeat',
  };

  const contentStyle = {
    padding: '40px 20px',
    maxWidth: '800px',
    margin: '0 auto',
    textAlign: 'center',
  };

  const tableStyle = {
    width: '100%',
    marginTop: '30px',
    borderCollapse: 'collapse',
  };

  const thTdStyle = {
    border: '1px solid #ccc',
    padding: '12px',
    fontSize: '16px',
  };

  const headerStyle = {
    backgroundColor: '#f0f8ff',
    fontWeight: 'bold',
  };

  return (
    <div style={{ backgroundColor: '#f0f8ff' }}>
      <div style={bannerStyle}></div>

      <div style={contentStyle}>
        <h1>How to Pay – High School</h1>
        <p>
          At Highlands College, we offer convenient payment options for our high school students.
          You can pay via bank transfer, mobile money, or in person at our finance office. 
          Please follow the instructions provided in your welcome packet or contact the school office for help.
        </p>

        <h2>2026 High School Registration Fees</h2>
        <ul style={{ textAlign: 'left', margin: '20px auto', maxWidth: '600px' }}>
          <li><strong>Grade 8 & 9:</strong></li>
          <ul>
            <li>New Registration: R1,600.00</li>
            <li>Re-Registration: R1,000.00 <em>(22 July – 31 October 2025)</em></li>
          </ul>
          <li><strong>Grade 10 & 11:</strong></li>
          <ul>
            <li>New Registration: R1,800.00</li>
            <li>Re-Registration: R1,200.00 <em>(22 July – 31 October 2025)</em></li>
          </ul>
        </ul>

        <h2>2026 Monthly Fees (Excl. Textbooks)</h2>
        <table style={tableStyle}>
          <thead>
            <tr style={headerStyle}>
              <th style={thTdStyle}>Grade</th>
              <th style={thTdStyle}>Monthly Fee (ZAR)</th>
              <th style={thTdStyle}>Annual Total (ZAR)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={thTdStyle}>Grade 8</td>
              <td style={thTdStyle}>2,100</td>
              <td style={thTdStyle}>25,200</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 9</td>
              <td style={thTdStyle}>2,100</td>
              <td style={thTdStyle}>25,200</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 10</td>
              <td style={thTdStyle}>2,300</td>
              <td style={thTdStyle}>27,600</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 11</td>
              <td style={thTdStyle}>2,450</td>
              <td style={thTdStyle}>29,400</td>
            </tr>
          </tbody>
        </table>

        <h2 style={{ marginTop: '40px' }}>Grade 12 – 2026 Payment Options</h2>
        <p><em>Includes registration, textbooks, matric camp & free matric jacket</em></p>
        <ul style={{ textAlign: 'left', margin: '20px auto', maxWidth: '700px' }}>
          <li>
            <strong>Option 1:</strong> One payment of <strong>R36,000</strong> before <strong>15 Jan 2026</strong>
          </li>
          <li>
            <strong>Option 2:</strong> Six payments of <strong>R6,000</strong> per month:
            <br /><em>(Dec 2025, Jan, Feb, Mar, Apr, May)</em>
          </li>
          <li>
            <strong>Option 3:</strong> 
            <ul>
              <li>R6,000 in December 2025</li>
              <li>3 payments of R10,000:
                <ul>
                  <li>1st: 31 Jan 2026</li>
                  <li>2nd: 31 Mar 2026</li>
                  <li>3rd: 31 May 2026</li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>

        <h3 style={{ marginTop: '40px' }}>Need Assistance?</h3>
        <p>Contact our office for help with payment options or account queries.</p>
      </div>
    </div>
  );
}

export default HighSchoolFees;
